export default "__VITE_ASSET__c743e6a3__"